import { render, staticRenderFns } from "./fatturazione.vue?vue&type=template&id=59bb5ce1"
import script from "./fatturazione.vue?vue&type=script&lang=js"
export * from "./fatturazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports